// extracted by mini-css-extract-plugin
export default {"noData":"Demographics_noData__iMmJT"};